import React, { useContext } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  useReactFlow,
} from '@xyflow/react';
import { StateContext } from '../../StateContainer';

const ActionButton = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  const { setDettagliNodi } = useContext(StateContext);
  const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const onEdgeClick = () => {
    setEdges((edges) => edges.filter((edge) => edge.id !== id));

    setDettagliNodi((prevNodi) => {
      const updatedNodi = { ...prevNodi };

      Object.keys(updatedNodi).forEach((nodoKey) => {
        if (updatedNodi[nodoKey].intents) {
          updatedNodi[nodoKey].intents = updatedNodi[nodoKey].intents.filter(
            (intent) => intent.id !== id
          );
        }
      });

      return updatedNodi;
    });
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          className="button-edge__label nodrag nopan"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          <button className="button-edge__button" onClick={onEdgeClick}>
            ×
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default ActionButton;
